<template>
  <a-layout :style="{background:'#f1f3f3',minHeight:'100vh'}">
    <a-layout-content>
      <a-row>
        <a-col type="flex" justify="space-around" align="middle" class="wemail-login-box">
          <img src="@/assets/wemail.svg" alt class="we__logo">
        </a-col>
      </a-row>
      <a-row>
        <a-col type="flex" justify="space-around" align="middle" :style="{fontSize: '1.2em', margin: '20px', fontWeight: 'bold'}">
          Reset Your Password
        </a-col>
      </a-row>
      <a-row type="flex" justify="space-around" align="middle">
        <a-col :span="8">
          <a-form
            id="components-form-demo-normal-login"
            class="login-form height-50"
          >
            <a-form-item
                  :validate-status="errors.hasOwnProperty('email') ? 'error' : 'validating'"
                  :help="errors.hasOwnProperty('email') ? errors.email[0] : ''"
            >
              <a-input
                placeholder="Email Address"
                v-model="form.email"
              >
                <a-icon slot="prefix" type="user" style="color: rgba(0,0,0,.25)"/>
              </a-input>
            </a-form-item>
            <a-form-item
                  :validate-status="errors.hasOwnProperty('password') ? 'error' : 'validating'"
                  :help="errors.hasOwnProperty('password') ? errors.password[0] : ''"
            >
              <a-input
                placeholder="Enter New Password"
                v-model="form.password"
                type="password"
              >
                <a-icon slot="prefix" type="setting" style="color: rgba(0,0,0,.25)"/>
              </a-input>
            </a-form-item>

              <a-form-item
                  :validate-status="errors.hasOwnProperty('password_confirmation') ? 'error' : 'validating'"
                  :help="errors.hasOwnProperty('password_confirmation') ? errors.password_confirmation[0] : ''"
            >
              <a-input
                type="password"
                placeholder="Enter Confirm Password"
                v-model="form.password_confirmation"
              >
                <a-icon slot="prefix" type="setting" style="color: rgba(0,0,0,.25)"/>
              </a-input>
            </a-form-item>
            <a-form-item>
              <a-button type="primary" @click.prevent="resetPassword" :loading="loading" class="login-form-button">Reset Password</a-button>
              Or <router-link :to="{name: 'login'}" tag="a">Back to login</router-link>
            </a-form-item>
          </a-form>
        </a-col>
      </a-row>
    </a-layout-content>
  </a-layout>
</template>

<script>
export default {
  data() {
    return {
      form: {
        token: '',
        email: '',
        password: '',
        password_confirmation: ''
      },
      errors: {},
      loading: false
    }
  },
  methods: {
    resetPassword() {
      this.loading = true;
      this.errors = {};
      this.form.token = this.$route.query.token;
      this.$store.dispatch("auth/RESET_PASSWORD", this.form)
        .then(() => {
          this.form.email = '';
          this.form.password = '';
          this.form.password_confirmation = '';
          this.loading = false;
          this.$weNotify("success", `Password reset done. Now login with new credentials.`);
        }).catch(error => {
          this.errors = error.data;
          if (error.data.token) {
            this.$weNotify("error", error.data.token);
          }
          this.loading = false;
        })
    }
  }
};
</script>
<style scoped>
.body {
  width: 100%;
}
.we__logo {
  height: 80px;
  width: 80px;
}
.wemail-login-box {
  margin-top: 10%;
}
#components-form-demo-normal-login .login-form {
  max-width: 300px;
}
#components-form-demo-normal-login .login-form-forgot {
  float: right;
}
#components-form-demo-normal-login .login-form-button {
  width: 100%;
}
</style>
